import getAppName from '@/functions/getAppName'

const isLoginHelpEnabled = () => {
	try {
		return JSON.parse(process.env.VUE_APP_LOGIN_HELP_ENABLED) === true
	} catch {
		return false
	}
}

const loadLoginHelpWidget = () => {
	const isLocal = location.hostname === 'localhost' || location.hostname.endsWith('.localhost')
	if (!isLoginHelpEnabled()) return
	if (document.querySelector('script[data-login-help-embed]')) return

	const appName = getAppName()
	if (!appName) return

	const supportOrigin = isLocal
		? 'http://localhost:8009'
		: `https://testcustomersupport.${appName.toLowerCase()}.com`
	window.__LOGIN_HELP_ORIGIN = supportOrigin

	const script = document.createElement('script')
	script.src = `${supportOrigin}/login-help-embed.js`
	script.async = true
	script.setAttribute('data-login-help-embed', '')
	document.body.appendChild(script)
}

export default loadLoginHelpWidget
